import { Tooltip } from "antd";
import styles from "./ViewSelector.module.css";
import { useGlobal } from "@vojomo-core/shared";

export const ViewSelector = () => {
  const { view, setView } = useGlobal();
  const isMyView = view === "my";
  const tooltipText = isMyView
    ? "Switch to the shared team roadmap."
    : "Switch to your personal roadmap view.";

  return (
    <Tooltip title={tooltipText}>
      <div className={styles.toggleContainer}>
        <button
          className={`${styles.toggleButton} ${isMyView ? styles.isActive : ""}`}
          onClick={() => setView("my")}
          type="button"
          aria-pressed={isMyView}
        >
          Solo
        </button>
        <button
          className={`${styles.toggleButton} ${!isMyView ? styles.isActive : ""}`}
          onClick={() => setView("team")}
          type="button"
          aria-pressed={!isMyView}
        >
          Team
        </button>
      </div>
    </Tooltip>
  );
};
